"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Logo = void 0;

var _react = _interopRequireDefault(require("react"));

var _ThemeConstant = require("../../constants/ThemeConstant");

var _AppConfig = require("../../configs/AppConfig");

var _reactRedux = require("react-redux");

var _utils = _interopRequireDefault(require("../../utils"));

var _antd = require("antd");

var useBreakpoint = _antd.Grid.useBreakpoint;

var getLogoWidthGutter = function getLogoWidthGutter(props, isMobile) {
  var navCollapsed = props.navCollapsed,
      navType = props.navType;
  var isNavTop = navType === _ThemeConstant.NAV_TYPE_TOP ? true : false;

  if (isMobile && !props.mobileLogo) {
    return 0;
  }

  if (isNavTop) {
    return 'auto';
  }

  if (navCollapsed) {
    return "".concat(_ThemeConstant.SIDE_NAV_COLLAPSED_WIDTH, "px");
  } else {
    return "".concat(_ThemeConstant.SIDE_NAV_WIDTH, "px");
  }
};

var getLogo = function getLogo(props) {
  var navCollapsed = props.navCollapsed,
      logoType = props.logoType;

  if (logoType === 'light') {
    if (navCollapsed) {
      return '/clPortal/img/Saarthi-sm-White.png';
    }

    return '/clPortal/img/Saarthi-white.png';
  }

  if (navCollapsed) {
    return '/clPortal/img/Saarthi-sm-Blue.png';
  }

  return '/clPortal/img/Saarthi-blue.png';
};

var getLogoDisplay = function getLogoDisplay(isMobile, mobileLogo) {
  if (isMobile && !mobileLogo) {
    return 'd-none';
  } else {
    return 'logo';
  }
};

var Logo = function Logo(props) {
  var isMobile = !_utils.default.getBreakPoint(useBreakpoint()).includes('lg');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: getLogoDisplay(isMobile, props.mobileLogo),
    style: {
      width: "".concat(getLogoWidthGutter(props, isMobile))
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: getLogo(props),
    alt: "".concat(_AppConfig.APP_NAME, " logo")
  }));
};

exports.Logo = Logo;

var mapStateToProps = function mapStateToProps(_ref) {
  var theme = _ref.theme;
  var navCollapsed = theme.navCollapsed,
      navType = theme.navType;
  return {
    navCollapsed: navCollapsed,
    navType: navType
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Logo);

exports.default = _default;